import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const TermsOfServicePage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | WINTRUST SOLUTIONS - Tax Consultant in Coimbatore</title>
        <meta name="description" content="Read the Terms of Service for WINTRUST SOLUTIONS. Understand the terms and conditions for using our tax consultancy, GST, and ITR filing services in Coimbatore." />
      </Helmet>

      <section className="bg-navy py-12">
        <div className="container-custom">
          <nav className="text-slate-400 text-sm mb-4">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-white">Terms of Service</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-heading">
            Terms of Service
          </h1>
        </div>
      </section>

      <section className="bg-white section-padding">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-slate max-w-none space-y-8">
            <p className="text-slate-600 text-lg">
              These Terms of Service ("Terms") govern your use of the WINTRUST SOLUTIONS website and the tax consultancy, GST, ITR, TDS, and business registration services we provide. By engaging our services or using our website, you agree to be bound by these Terms.
            </p>
            <p className="text-slate-500 text-sm">Last Updated: February 2026</p>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">1. Services Offered</h2>
              <p className="text-slate-600 mb-3">WINTRUST SOLUTIONS provides the following professional services:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>GST Registration and Return Filing (GSTR-1, GSTR-3B, Annual Returns)</li>
                <li>Income Tax Return (ITR) Filing for individuals, professionals, and businesses</li>
                <li>TDS Filing and Compliance (Quarterly Returns, Form 16/16A)</li>
                <li>Business Registration (Proprietorship, Partnership, MSME, Startup India, Company Incorporation)</li>
                <li>Health Insurance Advisory for individuals and businesses</li>
                <li>General tax consultancy and compliance advisory</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">2. Client Responsibilities</h2>
              <p className="text-slate-600 mb-3">As a client, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Provide accurate, complete, and timely information and documents required for the services.</li>
                <li>Respond to our requests for information or clarification in a timely manner.</li>
                <li>Review all filings and documents prepared by us before submission and notify us of any errors or discrepancies.</li>
                <li>Pay all applicable fees for the services rendered as per the agreed terms.</li>
                <li>Ensure that all information provided to us is truthful and not misleading.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">3. Our Responsibilities</h2>
              <p className="text-slate-600 mb-3">We commit to:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Providing professional, accurate, and timely tax consultancy and compliance services.</li>
                <li>Handling your financial information with the utmost confidentiality and security.</li>
                <li>Keeping you informed about the progress of your filings and any relevant deadlines.</li>
                <li>Advising you on the best course of action for your tax and compliance needs.</li>
                <li>Filing your returns and applications before the prescribed government deadlines.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">4. Fees and Payment</h2>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Service fees will be communicated to you upfront before the commencement of any service.</li>
                <li>Payment terms will be agreed upon at the time of engagement.</li>
                <li>Government fees, if applicable (e.g., registration fees), are separate from our service charges and are borne by the client.</li>
                <li>We reserve the right to revise our fees with prior notice to clients.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">5. Confidentiality</h2>
              <p className="text-slate-600">
                All information shared by you with WINTRUST SOLUTIONS, including financial records, personal details, and business information, will be treated as strictly confidential. We will not disclose your information to any third party except as required by law, regulation, or with your express consent. This obligation of confidentiality survives the termination of our professional relationship.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">6. Limitation of Liability</h2>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>WINTRUST SOLUTIONS shall not be held liable for any penalties, interest, or losses arising from inaccurate, incomplete, or untimely information provided by the client.</li>
                <li>Our liability is limited to the fees paid by the client for the specific service in question.</li>
                <li>We are not liable for delays caused by government portals, technical issues beyond our control, or force majeure events.</li>
                <li>We provide advisory services based on our interpretation of current tax laws. Tax laws are subject to change, and we are not liable for changes in interpretation by government authorities.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">7. Termination</h2>
              <p className="text-slate-600">
                Either party may terminate the engagement by providing written notice. In case of termination, the client is responsible for payment of all services rendered up to the date of termination. Any ongoing filings or applications in progress at the time of termination will be completed at the discretion of WINTRUST SOLUTIONS, subject to payment of applicable fees.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">8. Intellectual Property</h2>
              <p className="text-slate-600">
                All content on the WINTRUST SOLUTIONS website, including text, graphics, logos, and images, is the property of WINTRUST SOLUTIONS and is protected by applicable intellectual property laws. You may not reproduce, distribute, or use any content from our website without our prior written consent.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">9. Governing Law</h2>
              <p className="text-slate-600">
                These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these Terms or our services shall be subject to the exclusive jurisdiction of the courts in Coimbatore, Tamil Nadu, India.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">10. Changes to Terms</h2>
              <p className="text-slate-600">
                WINTRUST SOLUTIONS reserves the right to modify these Terms at any time. Updated Terms will be posted on this page with a revised "Last Updated" date. Continued use of our services after any changes constitutes your acceptance of the updated Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">11. Contact Us</h2>
              <p className="text-slate-600">
                If you have any questions about these Terms, please contact us:
              </p>
              <div className="bg-slate-50 p-6 rounded-lg mt-4 space-y-2 text-slate-600">
                <p><strong>WINTRUST SOLUTIONS</strong></p>
                <p>Email: wintrustsolutions@gmail.com</p>
                <p>Phone: +91 89409 88776</p>
                <p>Location: Coimbatore, Tamil Nadu, India</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfServicePage;
